import * as Sentry from "@sentry/react";

import "./i18n";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";

import App from "./app";
import reportWebVitals from "./reportWebVitals";

const isProduction = import.meta.env.MODE === "production";

Sentry.init({
  dsn: "https://47367463477cb33f277af3ce63c3685a@o4510708126056448.ingest.de.sentry.io/4510714886291536",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: import.meta.env.MODE,
  // Capture all errors in both environments
  sampleRate: 1.0,
  // Performance: 100% in prod, 10% in dev to reduce noise
  tracesSampleRate: isProduction ? 1.0 : 0.1,
  // Session replay: record 10% of sessions in prod, none in dev
  replaysSessionSampleRate: isProduction ? 0.1 : 0,
  // Always record sessions with errors
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

if (import.meta.hot) {
  import.meta.hot.accept();
}

// PWA service worker registration is handled by vite-plugin-pwa

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
